import { ClientSide } from "~/@types";
import { IInsight } from "~/@types/generated/contentful";
import InsightNavFloating from "../shared/InsightNavFloating";
import InsightNavShare from "./InsightNavShare";
import InsightNavActions from "./InsightNavActions";

type InsightNavMobileProps = {
  insight: ClientSide<IInsight>;
  disableDesktopFloat?: boolean;
};

export default function InsightNavMobile({ insight }: InsightNavMobileProps) {
  return (
    <InsightNavFloating>
      <div className="flex justify-between">
        <InsightNavActions insight={insight} showDownload={true} />
        <InsightNavShare insight={insight} />
      </div>
    </InsightNavFloating>
  );
}
